import { lazy } from "react";

const BaseRoute = lazy(() => import("./BaseRoute"));
const Landing = lazy(() => import("./Landing"));
const Projects = lazy(() => import("./Projects"));
const Experience = lazy(() => import("./Experience"));
const Blogs = lazy(() => import("./Blogs"));
const ViewBlog = lazy(() => import("./ViewBlog"));

// TODO: extract non-default lazy import logic to a separate reusable function

const ProjectProvider = lazy(() =>
  import("../contexts/ProjectContext").then((module) => ({
    default: module.ProjectProvider,
  }))
);

const ExperienceProvider = lazy(() =>
  import("../contexts/ExperienceContext").then((module) => ({
    default: module.ExperienceProvider,
  }))
);

const BlogProvider = lazy(() =>
  import("../contexts/BlogContext").then((module) => ({
    default: module.BlogProvider,
  }))
);

const ConstructedRoutes = {
  "/": {
    element: (
      <BaseRoute>
        <Landing />
      </BaseRoute>
    ),
  },
  "/projects": {
    element: (
      <ProjectProvider>
        <BaseRoute>
          <Projects />
        </BaseRoute>
      </ProjectProvider>
    ),
  },
  "/experience": {
    element: (
      <ExperienceProvider>
        <BaseRoute>
          <Experience />
        </BaseRoute>
      </ExperienceProvider>
    ),
  },
  "/blog": {
    element: (
      <BlogProvider>
        <BaseRoute>
          <Blogs />
        </BaseRoute>
      </BlogProvider>
    ),
  },
  "/blog/:blogId": {
    element: (
      <BlogProvider>
        <BaseRoute navigateDockVisible={false}>
          <ViewBlog />
        </BaseRoute>
      </BlogProvider>
    ),
  }
};

export default ConstructedRoutes;
